import {
  takeEvery,
  takeLatest,
  put,
  call,
  select
} from 'redux-saga/effects';
import pick from 'lodash/pick';

import axios from '../../axios-api';
import { getErrorMessage } from '../../common/utils';
import formClientActions from './actions';
import formClientConstants from './constants';
import formClientSelectors from './selectors';

const DEFAULT_SUBMIT_ERROR_MESSAGE = 'We couldn\'t upload one or more attachments, so your submission was not created. Please try again.';

export function* formClientInit(action) {
  try {
    const {
      formId,
      token
    } = action.payload;
    const apiClient = axios(token);

    const formResponse = yield call(apiClient.get, `/form/${formId}`);

    const {
      data: formData
    } = formResponse;

    yield put(formClientActions.formClientInitSuccess(formData));
  }
  catch (error) {
    yield put(formClientActions.formClientInitError());
  }
}

export function* formClientSubmit(action) {
  try {
    const {
      form,
      token
    } = action.payload;

    const apiClient = axios(token);

    const reqPayload = pick(form, ['formData', 'captchaToken']);

    const formId = yield select(formClientSelectors.getFormId);
    yield call(apiClient.post, `/form/${formId}/submit`, reqPayload);

    yield put(formClientActions.formClientSubmitSuccess());
  }
  catch (error) {
    const errorMessage = getErrorMessage(error, DEFAULT_SUBMIT_ERROR_MESSAGE);
    yield put(formClientActions.formClientSubmitError(errorMessage));
  }
}

export default function* FormClientSage() {
  yield takeEvery(formClientConstants.INITIALIZE_FORM_CLIENT, formClientInit);
  yield takeLatest(formClientConstants.SUBMIT_FORM, formClientSubmit);
}
